import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clearCart } from "../../redux/slices/cart";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "../PaymentForm/PaymentForm";
import "./PaymentStep.css";

const stripePromise = loadStripe(
  "pk_test_51PVblCFhNDvgGzPkFthvBmIwfdJ9qJMZCU9GqCNif2oF6hbTdJVdDBb0Ffmg9Bao1xmbfbYTGBQiO8QRylJ16r8p00zGKb4lPS"
);

const PaymentStep = ({ orderData, onBack }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFreeOrder, setIsFreeOrder] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const total = parseFloat(orderData?.discountedTotal || 0);
    
    if (total === 0) {
      setIsFreeOrder(true);
      setLoading(false);
      return; // Do NOT clear cart here anymore
    }

    const secret = orderData?.stripe_payment_intent_client_secret;

    if (secret) {
      setClientSecret(secret);
      setLoading(false);
    } else {
      setError("Payment information is missing. Please go back and try again.");
      setLoading(false);
    }
  }, [orderData]);

  if (loading) {
    return (
      <section className="PaymentStep">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <p>Loading payment form...</p>
        </div>
      </section>
    );
  }

  if (isFreeOrder) {
    return (
      <section className="PaymentStep">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <h2 style={{ color: "#4caf50", marginBottom: "20px" }}>
            🎉 Order Successful!
          </h2>
          <p>Your total was $0.00, so no payment is required.</p>
          <p>Thank you for your order #{orderData.orderId}!</p>
          <button
            onClick={() => {
              dispatch(clearCart()); // Clear cart when leaving the screen
              window.location.href = "/";
            }}
            style={{
              marginTop: "20px",
              backgroundColor: "#007cba",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Continue Shopping
          </button>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="PaymentStep">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <p style={{ color: "red", marginBottom: "20px" }}>{error}</p>
          <button
            onClick={onBack}
            style={{
              backgroundColor: "#007cba",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Back to Billing
          </button>
        </div>
      </section>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <PaymentForm
        orderData={orderData}
        onBack={onBack}
        clientSecret={clientSecret}
      />
    </Elements>
  );
};

export default PaymentStep;